import { ApiBeacon } from "./service/ApiBeacon";
import { ApiCountry } from "./service/ApiCountry";
import { ApiOrganization } from "./module/organization/organization-service/ApiOrganization";
import { ApiMonitorEvent } from "./service/ApiMonitorEvent";
import { ApiPromotionCode } from "./service/ApiPromotionCode";
import { ApiUpload } from "./service/ApiUpload";
import { ApiUser } from "./service/ApiUser";
import { Config } from "./config";
import { toastr, ToastrEmitter } from "react-redux-toastr";
import { AuthStorage } from "./service/AuthStorage";
import { ApiVenue } from "./service/ApiVenue";
import { ApiVenueTag } from "./service/ApiVenueTag";
import { ApiPartnership } from "./service/ApiPartnership";
import { ApiEmailTemplate } from "./service/ApiEmailTemplate";
import { ApiAdmin } from "./service/ApiAdmin";
import { ApiMemberCardPool } from "./service/ApiMemberCardPool";
import { ApiShop } from "./module/shop/service/ApiShop";

export interface ServiceContainer {
  apiCountry: ApiCountry;
  apiUpload: ApiUpload;
  apiUser: ApiUser;
  apiVenue: ApiVenue;
  apiTag: ApiVenueTag;
  toastr: ToastrEmitter;
  authStorage: AuthStorage;
  apiOrganization: ApiOrganization;
  apiMonitorEvent: ApiMonitorEvent;
  apiBeacon: ApiBeacon;
  apiPromotionCode: ApiPromotionCode;
  apiPartnership: ApiPartnership;
  apiEmailTemplate: ApiEmailTemplate;
  apiMemberCardPool: ApiMemberCardPool;
  apiAdmin: ApiAdmin;
  apiShop: ApiShop;
}

export const serviceContainerBuilder = (config: Config): ServiceContainer => {
  const apiUpload = new ApiUpload(config.apiEndpoint);
  const apiUser = new ApiUser(config.apiEndpoint);
  const authStorage = new AuthStorage();
  const apiVenue = new ApiVenue(config.apiEndpoint);
  const apiTag = new ApiVenueTag(config.apiEndpoint);
  const apiCountry = new ApiCountry(config.apiEndpoint);
  const apiMonitorEvent = new ApiMonitorEvent(config.apiEndpoint);
  const apiOrganization = new ApiOrganization(config.apiEndpoint);
  const apiBeacon = new ApiBeacon(config.apiEndpoint);
  const apiPromotionCode = new ApiPromotionCode(config.apiEndpoint);
  const apiPartnership = new ApiPartnership(config.apiEndpoint);
  const apiEmailTemplate = new ApiEmailTemplate(config.apiEndpoint);
  const apiAdmin = new ApiAdmin(config.apiEndpoint);
  const apiMemberCardPool = new ApiMemberCardPool(config.apiEndpoint);
  const apiShop = new ApiShop(config.apiEndpoint);

  return {
    apiCountry,
    apiUpload,
    apiUser,
    apiVenue,
    apiTag,
    toastr,
    authStorage,
    apiMonitorEvent,
    apiOrganization,
    apiBeacon,
    apiPromotionCode,
    apiPartnership,
    apiEmailTemplate,
    apiAdmin,
    apiMemberCardPool,
    apiShop,
  };
};
